export default [
    {
      path: '/rent/v2/discount-mall',
      name: 'discountMallList',
      component: () => import('@/pages/discountMall/discountMallList'),
      meta: { title: '优惠商城', requireAuth: true },
    },
]


// WEBPACK FOOTER //
// ./src/pages/discountMall/discountMall.js